import * as yup from 'yup';
import { FIELD_LIMITS } from 'utils/character-count-utils';

const checkIfAnyItemIsAdded = (value: any, textContext: yup.TestContext) => {
  const { session, form, content } = textContext.parent;
  if (session.length + content.length + form.length === 0) {
    return false;
  }
  return true;
};

const courseModulesFormValidation = yup.object().shape({
  modules: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().trim().required('Module name is a required field. ').max(FIELD_LIMITS.MODULE_NAME.maxLength, `Module name must be at most ${FIELD_LIMITS.MODULE_NAME.maxLength} characters`),
        description: yup.string().trim().test(
          'length-limit',
          `Description must be at most ${FIELD_LIMITS.MODULE_DESC.maxLength} characters`,
          (value) => (value?.replace(/(<([^>]+)>)/gi, '')?.replace(/[\r\n]+/gm, '')?.length || 0) <= FIELD_LIMITS.MODULE_DESC.maxLength,
        ),
        badge: yup.object().shape({
          badgeTitle: yup.string().trim(),
          badgeDescription: yup.string().trim(),
          badgeImagUrl: yup.string().trim(),
        }),
        session: yup
          .array()
          .label('Module Sessions')
          .test(
            'session',
            'Add at least one session, form or media item to create this module. ',
            checkIfAnyItemIsAdded,
          ),
        forms: yup
          .array()
          .of(
            yup.object().shape({
              id: yup.string().label('Form id'),
              submission: yup.string().label('Form submission'),
            }),
          )
          .nullable()
          .label('Forms'),
        content: yup.array(),
      }),
    )
    .min(1),
});

export const moduleFieldConfigs = {
  name: FIELD_LIMITS.MODULE_NAME,
  description: FIELD_LIMITS.MODULE_DESC,
};

export default courseModulesFormValidation;
